import axiosConfig from "./axiosConfig";
import { LandlordResearchResponse } from "./postVoaResearchLandlord";

// The promoted-lead sibling of postVoaResearchLandlord: runs the agentic
// landlord-research agent against a Lead and writes the cited candidates
// onto lead.agenticData. Same LRO shape.
const postLeadResearchLandlord = async (
  authToken: string,
  leadId: string
): Promise<LandlordResearchResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${leadId}/research-landlord`,
    {},
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadResearchLandlord;
